import script from "./EtfCustomSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./EtfCustomSearch.vue?vue&type=script&setup=true&lang=js"

import "./EtfCustomSearch.vue?vue&type=style&index=0&id=e9e4d312&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9e4d312"]])

export default __exports__